import { render, staticRenderFns } from "./image_matting.vue?vue&type=template&id=555caf94&scoped=true"
import script from "./image_matting.vue?vue&type=script&lang=js"
export * from "./image_matting.vue?vue&type=script&lang=js"
import style0 from "./image_matting.vue?vue&type=style&index=0&id=555caf94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555caf94",
  null
  
)

export default component.exports